import {inject} from "vue";

export const DataContext = Symbol('DataContext');

export function useDataContext(component) {
    const context = inject(DataContext, null);
    if (context === null) {
        const err = new Error(`<${component} /> is missing a parent <DataComponent /> component.`);
        if (Error.captureStackTrace)
            Error.captureStackTrace(err, useDataContext);
        throw err;
    }
    return context;
}
